import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import ViewModel from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsEditor/productAd';
import { getODataErrors, isCampaignApiError } from '@bingads-webui-component-legacy/api-errors-campaign/index';

export default class View extends Backbone.View {
  initialize(options = {}) {
    this.options = options;

    this.viewModel = new ViewModel(this.options);
  }

  render() {
    ko.applyBindings(this.viewModel, this.el);
  }

  validate() {
    return true;
  }

  toObject() {
    return {};
  }

  handleApiErrors(response) {
    this.viewModel.errors.add(_.isEmpty(response) ? undefined : getODataErrors(response.errors));
  }

  clearApiErrors() {
    this.viewModel.errors.clear(isCampaignApiError);
  }
}
